<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <AmountByClient />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import AmountByClient from '@/components/reports/service/amountbyclient/List'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'AmountByClientReport',
  components: {
    PageTitle,
    PageRowWrapper,
    AmountByClient,
    ActionButton
  }
}
</script>
